// extracted by mini-css-extract-plugin
module.exports = {"tabPanel":"_6c97a9ff"};